
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.5 15s.149-.54.149-.64c.2 0 .274.01.274.01l1.91.124s.12.028.12-.122v-.351s0-.1-.2-.2-2.16-1.047-2.16-1.047.758-2.459.808-3.21c.05-.75 0-1.001 0-1.001h.4s-.05 2.403.452 2.403c.5 0 .4-1.502.4-1.752s-.05-.701-.05-.701l4.307-.25.45.3s.1-.3 0-.4c-.1-.1-.2-.351-.2-.351s-.05-.15-.05-.25 0-.301-.15-.301c-.1 0-5.509-.801-5.509-.801S8.601 1.002 7.45 0c-1.102 1.002-.901 6.36-.901 6.36s-5.409.8-5.509.8c-.1 0-.15.201-.15.301 0 .1-.05.3-.05.3s-.15.251-.2.351c-.1.1 0 .4 0 .4l.45-.3 4.307.25s-.05.451-.05.702-.1 1.752.4 1.752.451-2.403.451-2.403h.4s-.05.3 0 1.001c.05.701.823 3.254.823 3.254s-1.974.903-2.174 1.003c-.3.1-.3.2-.3.2v.35c0 .15.15.15.15.15l2.052-.1s.01-.006.21-.006c0 .1.141.635.141.635z"}})])
          )
        }
      }
    